// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input-zero-value":"index__input-zero-value___3n8Du","inputZeroValue":"index__input-zero-value___3n8Du"};
    if(module.hot) {
      // 1747017328520
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  